import React, { useEffect, useState } from 'react';
import { Diagnostics } from '../Buttons/IconButton/Icons';
import { ThumbRating } from '../Ratings/Ratings';
import styled from 'styled-components';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';

const DiagnosticsContainer = styled.div`
	path {
		fill: #ffffff99;
	}
	outline: 1px solid var(#ffffff33);
	background: #00000099;
	&:hover {
		path {
			fill: #ffffff;
		}
	}
`;

interface Props {
	message?;
	messageType?;
	messageKey?;
	data?;
	extra?;
	showFeedbackIcons?;
	searchStatus?;
	customStateInfo?;
	extraDisambInformation?;
	timeStamp?;
	workflowFlag?;
	popUpSnackBar;
	voiceResponse?;
	diagnosticInfo?;
	openThumbsPopup?;
	thumbFilledUp?;
	messageId?;
	productCarousel?;
	showForm?;
	multiChoice?;
	colorMode?;
	colorScale?;
	handleSubmit?;
	selectedTheme?;
}

function returnExtraData(extraDisambInformation) {
	try {
		let titleText;
		if (Object.keys(extraDisambInformation)) {
			titleText = `
                Recognised Information
                Entity: ${extraDisambInformation.matchedEntity}
                Intent: ${extraDisambInformation.matchedIntent}
                Question: ${extraDisambInformation.matchedQn}
                Entity Heirarchy: ${extraDisambInformation.entityHeirarchy}
                Semantics Identified: ${extraDisambInformation.semantics}
                Variations Matched: ${extraDisambInformation.variationMatched}
                Intent Score: ${extraDisambInformation.intentScore}
                Intent Not Match: ${extraDisambInformation.intentNotMatch}
                Reverse Intent Score: ${extraDisambInformation.reverseIntentScore}
                Reverse Intent Not Match: ${extraDisambInformation.reverseIntentNotMatch}
                Semantic Sequence: ${extraDisambInformation.semanticsSequence}
                ContextEnable: ${extraDisambInformation.entityInContext}
            `;
		}
		return titleText;
	} catch (e) {
		return '';
	}
}

const MessageFeedback = (props: Props) => {
	const [width, setWidth] = React.useState<any>(0);
	const [border, setBorder] = React.useState<any>(false);

	useEffect(() => {
		if (props.productCarousel) {
			setWidth('97.5%');
			setBorder(true);
		} else if (props.showForm) {
			setWidth('396px');
			setBorder(false);
		} else if (document.querySelectorAll('.list-carousel-message').length > 0) {
			setWidth(
				document.querySelectorAll('.list-carousel-message').length > 0 &&
					document.querySelectorAll('.list-carousel-message')[
						document.querySelectorAll('.list-carousel-message') &&
							document.querySelectorAll('.list-carousel-message').length - 1
					].clientWidth
			);
			setBorder(false);
		} else if (document.querySelectorAll('.msg-server').length > 0) {
			setBorder(false);
			setWidth(
				document.querySelectorAll('.msg-server').length > 0 &&
					document.querySelectorAll('.msg-server')[
						document.querySelectorAll('.msg-server') &&
							document.querySelectorAll('.msg-server').length - 1
					].clientWidth
			);
		} else {
			setBorder(false);
		}
	}, []);

	return (
		<>
			<div
				className={`sf-message-feedback ${loadStateSession('selectedTheme')} ${
					props.productCarousel ? 'ff-productcard-feedback' : ''
				} ${props.showFeedbackIcons ? 'monacoFeedback' : ''}`}
				style={{
					alignItems: props.messageType == 'server' ? 'center' : 'flex-end',
					borderTop: border ? '1.2px solid rgba(0, 0, 0, 0.2)' : 'none',
					maxWidth:
						document.querySelectorAll('.ff-productDisplay-content').length > 0
							? 'initial'
							: 'initial',
				}}
			>
				<div className='sf-message-feedback-packs time-pack'>
					{props.productCarousel && (
						<div
							className={`sf-multiple-result-w ff-feedback ${props.colorMode}`}
						>
							{typeof props.multiChoice !== 'undefined' &&
								props.multiChoice.items.length > 0 &&
								props.multiChoice.items.map((item) => {
									return (
										<div
											className='multi-choice-option'
											onClick={() => {
												window['autosubmit'](item.actionText);
											}}
										>
											{item.actionText}
										</div>
									);
								})}
						</div>
					)}
					<div
						className={`sf-time-wrapper timestamp-text ${props.messageType}`}
					>
						{props.timeStamp}
					</div>
					{props.diagnosticInfo &&
					props.diagnosticInfo.faqFinalResponseDebugInfo &&
					props.diagnosticInfo.faqFinalResponseDebugInfo[0] &&
					props.diagnosticInfo.faqFinalResponseDebugInfo[0].matchedIntent !==
						'' &&
					props.messageType == 'server' &&
					!props.showFeedbackIcons ? (
						<DiagnosticsContainer
							title={returnExtraData(
								props.diagnosticInfo.faqFinalResponseDebugInfo[0]
							)}
							className='diagnostics-button'
						>
							<Diagnostics />
						</DiagnosticsContainer>
					) : null}
				</div>
				{props.showFeedbackIcons ? (
					<div className='sf-message-feedback-packs'>
						<ThumbRating
							messageKey={props.messageKey}
							data={props.data}
							popUpSnackBar={props.popUpSnackBar}
							size={'small'}
							voiceResponse={props.voiceResponse}
							isResponselevelFeedback={true}
							openThumbsPopup={props.openThumbsPopup}
							thumbFilledUp={props.thumbFilledUp}
							messageId={props.messageId}
							colorMode={props.colorMode}
						/>

						{props.diagnosticInfo &&
						props.data.isInsideAware &&
						props.diagnosticInfo.faqFinalResponseDebugInfo &&
						props.diagnosticInfo.faqFinalResponseDebugInfo[0] &&
						props.diagnosticInfo.faqFinalResponseDebugInfo[0].matchedIntent !==
							'' ? (
							<DiagnosticsContainer
								title={returnExtraData(
									props.diagnosticInfo.faqFinalResponseDebugInfo[0]
								)}
								className='diagnostics-button'
							>
								<Diagnostics />
							</DiagnosticsContainer>
						) : null}
					</div>
				) : null}
			</div>
		</>
	);
};

export default MessageFeedback;
